import * as React from "react";
import { CSSProperties, ReactNode } from "react";
import styled from "styled-components";
import Row from "../../../../../Layout/PageGrid/Row";
import Col from "../../../../../Layout/PageGrid/Col";
import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";
import RouteTitle from "./RouteTitle";
import RouteTypeField from "./RouteTypeField";
import AddGsdb from "./AddGsdb/AddGsdb";
import ExpireButton from "./ExpireButton";
import DuplicateButton from "./DuplicateButton";
import LaunchBatch from "./LaunchBatch";
import RemoveRoute from "./RemoveRoute";
import { InformationButton } from "./InformationButton";

type StyledFlexAlignCenterProps = {
  children?: ReactNode;
};
const StyledFlexAlignCenter = styled.div<StyledFlexAlignCenterProps>`
  display: flex;
  align-items: center;
  flex-grow: 1;
  flex-shrink: 1;
`;

type StyledFlexAlignEndProps = {
  style?: CSSProperties;
  children?: ReactNode;
};
export const StyledFlexAlignEnd = styled.div<StyledFlexAlignEndProps>`
  display: flex;
  align-items: end;
  flex-grow: 1;
`;

type Props = {
  readonly route: FtlRouteViewModel;
  readonly toggleCardExpansion: (routeId: number) => void;
  readonly isReadonly: boolean;
};

export default function FtlRouteHeader({ route, toggleCardExpansion, isReadonly }: Props) {
  return (
    <div style={{ marginBottom: "1.5rem" }}>
      <RouteTitle route={route} />
      <Row gap="25px" marginBottom="0">
        <Col width="30%">
          <StyledFlexAlignCenter>
            <RouteTypeField route={route} isReadonly={isReadonly} />
          </StyledFlexAlignCenter>
        </Col>
        <Col width="25%">
          <LaunchBatch route={route} isReadonly={isReadonly} />
        </Col>
        <Col width="40%">
          <AddGsdb route={route} isReadonly={isReadonly} />
        </Col>
        <Col width="40%">{isReadonly ? <div /> : <ExpireButton route={route} />}</Col>
        <Col width="40%">{isReadonly ? <div /> : <DuplicateButton route={route} />}</Col>
        <Col width="40%">
          <InformationButton onClick={() => toggleCardExpansion(route.RouteId)} />
        </Col>
        {isReadonly ? <div /> : <RemoveRoute route={route} />}
      </Row>
    </div>
  );
}
